import React from "react";
import {
  Grid,
  Typography,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Button,
} from "@mui/material";


const YesNoQuestion = ({ questionData, update }) => {
  const [question, setQuestion] = React.useState(questionData);
  const [choice, setChoice] = React.useState(null);

  const handleChange = (val) => {
    if (!val) {
      setChoice(null);
      update("clear", questionData._id);
      return
    }
    setChoice(val);
    update("add", questionData._id, val);
  }

  return (
    <Grid item>
      <Paper elevation={1} style={{ padding: 10 }}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item md={6} xs={12}>
            <Typography>{question?.question}</Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <RadioGroup row>
              <FormControlLabel value="yes" control={<Radio onChange={() => handleChange('yes')} checked={choice === 'yes' ? true : false}/>} label="Yes" />
              <FormControlLabel value="no" control={<Radio onChange={() => handleChange('no')} checked={choice === 'no' ? true : false}/>} label="No" />
            </RadioGroup>
          </Grid>

          {choice ? (
            <Grid item xs={12} md={2}>
              <Button variant="contained" onClick={() =>  setChoice(null)}>
                clear{" "}
              </Button>
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};

export default YesNoQuestion;
